import { motion } from "framer-motion";
import { LuArrowRight, LuMail, LuMapPin } from "react-icons/lu";
import { useLang } from "../i18n";
import { contactContent } from "../data/content";
import { useDemoModal } from "../context/DemoModalContext";
import "./Contact.css";

export default function Contact() {
  const { t } = useLang();
  const { open: openDemoModal } = useDemoModal();

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-card">
          <motion.div
            className="contact-copy"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.5 }}
          >
            <span className="section-eyebrow contact-eyebrow">
              {t(contactContent.eyebrow)}
            </span>
            <h2 className="section-heading contact-heading">
              {t(contactContent.title)}
            </h2>
            <p className="section-kicker contact-kicker">
              {t(contactContent.kicker)}
            </p>
            <div className="contact-ctas">
              <button
                type="button"
                className="btn btn-primary"
                onClick={openDemoModal}
              >
                {t(contactContent.demoSubject)}
                <LuArrowRight size={18} aria-hidden />
              </button>
              <a
                href={`mailto:${contactContent.email.value}`}
                className="btn btn-ghost contact-email-btn"
              >
                {contactContent.email.value}
              </a>
            </div>
          </motion.div>

          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.55, delay: 0.1 }}
          >
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <LuMapPin size={18} aria-hidden />
              </div>
              <div>
                <strong>{t(contactContent.address.label)}</strong>
                <p>
                  {contactContent.address.lines.map((line, idx) => (
                    <span key={line}>
                      {line}
                      {idx < contactContent.address.lines.length - 1 && <br />}
                    </span>
                  ))}
                </p>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <LuMail size={18} aria-hidden />
              </div>
              <div>
                <strong>{t(contactContent.email.label)}</strong>
                <p>
                  <a href={`mailto:${contactContent.email.value}`}>
                    {contactContent.email.value}
                  </a>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
